import React from "react";
import styles from "./PeopleUI.module.css";
import chrome from "../../../components/common/PageChrome.module.css";
import { formatCompact } from "../../../utils/costUtils";

// Profit / month with the margin underneath; red when it's a loss.
export default function ProfitCell({ costs, symbol }) {
  if (!costs.costMonth && !costs.billed) return "—";
  return (
    <span>
      <span className={costs.profit < 0 ? styles.profitNegative : styles.profitPositive}>
        {formatCompact(symbol, costs.profit)}
      </span>
      <span className={chrome.cellSub}>
        {costs.margin == null ? "Nothing billed" : `${Math.round(costs.margin * 100)}% margin`}
      </span>
    </span>
  );
}
